import {
  DataTypeStore,
  EntityFieldRelationshipType,
  getLayoutByIdApi,
  getSubResources,
  LayoutElementType,
  LayoutResponseType,
  showLoader,
  hideLoader,
  getLayoutByEntityIdAndTypeApi,
  // Might need later
  // showPDF,
} from '@app-store'
import { Modal, MODE_CONSTANTS, OnColumnClickCallbackType } from '@ui-kit'
import { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import MultiUploadWrapper from '../MultiUploadWrapper'
import {
  RECORD_STATUS,
  ShortcutKeys,
  TAB_INDEX,
} from '../../constants/form.constants'
import { LAYOUT_TYPE_NAMESPACE, NAMESPACES } from '../../utils/constants'
import { v4 } from 'uuid'
import { AddDataModal } from '../MultiLookupRowRender'
import { ListingTable } from './ListingTable'
import { ListingTableProps } from '../../types/listingTable.types'
import { useAppDispatch } from '../../utils/agent.store'
import { getElementFromAddedFields } from '../../utils/form.utils'
// TODO: might need later
// import { useLocation } from 'react-router-dom'
// import { useAppDispatch } from '../../utils/agent.store'

export const getMultiLookUpForListingTable = (
  targetEntityRelationship: EntityFieldRelationshipType,
  _entityName: string,
  _accessor: string,
  _layout: LayoutResponseType,
  _addDraftText: boolean
) => {
  const MultiLookupForListingTable = (
    row: DataTypeStore,
    _rowIndex: number,
    _onColumnClick: OnColumnClickCallbackType<DataTypeStore>,
    _isDisabled: boolean,
    _tabIndex?: number
  ) => {
    const dispatch = useAppDispatch()
    const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
    const [isOpenMultiLookupModal, setIsOpenMultiLookupModal] =
      useState<boolean>(false)
    const [entityDetails, setEntityDetails] = useState<{
      layout_id: number
      entity_id: number
      entity_name: string
    } | null>(null)
    const [unassignTableKey, setUnassignTableKey] = useState(0)
    const fetchUnassignedDataCallback: ListingTableProps['dataFetchCallback'] =
      async (payload) => {
        try {
          const response = await getSubResources(
            entityDetails?.entity_name ?? '',
            entityDetails?.entity_id?.toString() ?? '',
            entityDetails?.layout_id?.toString() ?? '',
            targetEntityRelationship?.relation_identifier ?? '',
            false,
            row?.id?.toString() ?? '',
            +payload.page,
            +payload.size,
            undefined,
            payload.filters,
            payload.select,
            payload.related_entities
          )

          return response.data
        } catch (err) {
          console.error(err)
        }
      }
    const fetchEntityListing = async (entityId: string, layoutId: string) => {
      dispatch(showLoader())
      try {
        if (layoutId) {
          const response = await getLayoutByIdApi({ entityId, layoutId })
          setListingLayout(response?.data)
        }
      } catch (err) {
        console.error(err)
      } finally {
        dispatch(hideLoader())
      }
    }
    const closeMultiLookupFieldModal = () => {
      setIsOpenMultiLookupModal(false)
    }

    useEffect(() => {
      if (entityDetails?.entity_id && isOpenMultiLookupModal) {
        fetchEntityListing(
          entityDetails?.entity_id?.toString() ?? '',
          entityDetails?.layout_id?.toString() ?? ''
        )
      }
    }, [entityDetails, isOpenMultiLookupModal])

    useEffect(() => {
      if (targetEntityRelationship && isOpenMultiLookupModal) {
        const fetchEditLayout = async () => {
          dispatch(showLoader())
          try {
            const entityId =
              targetEntityRelationship.target_entity_id?.toString() ?? ''

            const response = await getLayoutByEntityIdAndTypeApi({
              entityId: entityId,
              type: LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING,
              isDefault: true,
            })
            const layout = response?.data?.[0]
            setEntityDetails({
              layout_id: layout?.id,
              entity_id: layout?.entity_id,
              entity_name: layout?.entity_name,
            })
          } catch (err) {
            console.error(err)
          } finally {
            dispatch(hideLoader())
          }
        }
        fetchEditLayout()
      }
    }, [targetEntityRelationship, isOpenMultiLookupModal])

    useEffect(() => {
      if (listingLayout && isOpenMultiLookupModal)
        setUnassignTableKey((prev) => prev + 1)
    }, [listingLayout, isOpenMultiLookupModal])

    return (
      <div>
        <button
          type="button"
          className="text-blue-500 underline cursor-pointer"
          onClick={() => setIsOpenMultiLookupModal(true)}
        >
          {NAMESPACES.VIEW_RECORDS}
        </button>
        {isOpenMultiLookupModal && (
          <AddDataModal>
            <Modal
              isOpen={isOpenMultiLookupModal}
              closeModal={closeMultiLookupFieldModal}
              closeModalOnOutsideClick={false}
              showCloseButton={true}
              width="min-w-[75vw] max-w-[60%] h-fit"
            >
              <div className="p-4">
                <span className="font-medium text-xl font-primary cursor-pointer">
                  {listingLayout?.entity?.plural_label
                    ?.replace('_', ' ')
                    .toLowerCase()
                    .replace(/\b\w/g, (c) => c.toUpperCase())}
                </span>
              </div>
              <div className="p-4">
                {listingLayout && entityDetails && (
                  <ListingTable
                    refetchKey={unassignTableKey}
                    dataFetchCallback={fetchUnassignedDataCallback}
                    entityId={Number(entityDetails?.entity_id)}
                    entityName={entityDetails?.entity_name ?? ''}
                    layout={listingLayout}
                    tabIndex={TAB_INDEX}
                    hideFilters={true}
                  />
                )}
              </div>
            </Modal>
          </AddDataModal>
        )}
      </div>
    )
  }

  return MultiLookupForListingTable
}
export const getMultiUploadForListingTable = (
  entityName: string,
  accessor: string,
  layout: LayoutResponseType,
  addDraftText: boolean
) => {
  const MultiUploadForListingTable = (
    // TODO: memorize it.
    row: DataTypeStore,
    rowIndex: number,
    onColumnClick: OnColumnClickCallbackType<DataTypeStore>,
    isDisabled: boolean,
    tabIndex?: number
  ) => {
    // TODO: MIght need later
    // const location = useLocation()
    // const dispatch = useAppDispatch()
    // const isOnWorkflowPage = location.pathname.includes('workflow')

    const divRef = useRef<HTMLDivElement>()
    const [renderMultiUpload, setRenderMultiUpload] = useState<{
      isOpen: boolean
      element: undefined
      id: string | undefined
    }>({
      isOpen: false,
      element: undefined,
      id: '',
    })

    // TODO: might need later
    // const sharePdfDocToRoot = async (row: DataTypeStore) => {
    //   const docId = row['document_upload.id']?.toString();
    //   if (docId) {
    //     dispatch(
    //       showPDF({
    //         docId: docId,
    //       })
    //     )
    //   }
    // }

    const getKeyName = (val: LayoutElementType) =>
      (val.parent ? val.parent.lookupKeyName + '.' : '') + val.keyName
    const onClick = () => {
      let layoutDataForMulti
      ;(
        layout?.layout_data?.pages?.[0].rows?.[0].columns?.[0].elements ?? []
      ).forEach((val) => {
        if (getKeyName(val) === accessor) {
          layoutDataForMulti = getElementFromAddedFields(
            val,
            layout?.entity_id?.toString(),
            layout?.layout_data?.added_fields
          )
        }
      })

      // Might need later
      // if (!isOnWorkflowPage || !row?.[`document_upload.attachment`]) {
      setRenderMultiUpload({
        isOpen: true,
        element: layoutDataForMulti,
        id: row?.[accessor + '.id']
          ? row?.[accessor + '.id']?.toString()
          : NAMESPACES.NO_DATA,
      })
      // } else {
      //   sharePdfDocToRoot(row)
      // }
    }

    const getComponentText = () => {
      if (addDraftText && row.record_status === RECORD_STATUS.DRAFT)
        return '(Draft) View Documents'
      return 'View Documents'
    }

    useEffect(() => {
      const id = v4()
      const div = document.createElement('div')
      div.id = id
      document.body.appendChild(div)
      divRef.current = div

      return () => {
        document.body.removeChild(div)
      }
    }, [])

    return (
      <div>
        <div
          className={`w-full  block truncate text-xs font-light ${
            isDisabled ? 'text-secondary-200' : 'text-secondary-500  '
          } `}
          onClick={onClick}
          tabIndex={tabIndex}
          role="button"
          onKeyDown={(e) => {
            if (
              e?.key === ShortcutKeys.Enter ||
              e?.key === ShortcutKeys.Space
            ) {
              e?.preventDefault()
              onClick()
            }
          }}
        >
          {getComponentText()}
        </div>
        {renderMultiUpload?.element &&
          renderMultiUpload?.isOpen &&
          ReactDOM.createPortal(
            //using Portal bcz Modal doesn't work inside Table renderComponent
            <MultiUploadWrapper
              id={renderMultiUpload?.id?.toString() ?? ''}
              element={renderMultiUpload?.element}
              mode={MODE_CONSTANTS.EDIT}
              entityName={entityName}
              isOpenForListing={renderMultiUpload?.isOpen}
              setRenderMultiUpload={setRenderMultiUpload}
              fullLayout={layout}
              dataId={row?.id as number}
              onUpload={(newID: number) => {
                row[accessor + '.id'] = newID
              }}
            />,
            divRef?.current || document.createElement('div')
          )}
      </div>
    )
  }

  return MultiUploadForListingTable
}
